import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const CurrencyRatePlugin = () => {
  const [configID, setConfigId] = useState(0)

  const [currencyRateConfig, setCurrencyRateConfig] = useState<any>({
    rate: 0,
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.value
    setCurrencyRateConfig({...currencyRateConfig, [name]: value})
  }

  const onBlurUpdate = () => {
    updateConfiguration(currencyRateConfig)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('currency-rate')
    if (result.success) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setCurrencyRateConfig({
        rate: parsedData?.rate,
      })
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>Currency Rate settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Currency Rate</strong>
            </p>
            <p className='text-muted'>this rate store in USD</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='number'
                className='form-control'
                name='rate'
                value={currencyRateConfig.rate}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
                step='0.01'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CurrencyRatePlugin
